import { render, staticRenderFns } from "./TgAboutCard.vue?vue&type=template&id=935a1dfa&"
import script from "./TgAboutCard.vue?vue&type=script&lang=js&"
export * from "./TgAboutCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports